import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import FilterComponents from "../FilterComponents/FilterComponents";
import { chartObj } from "./ChartConstants";
import TrendsList from "./TrendsList";
import Chart from "./Chart";
import TrendsBreadCrumb from "./TrendsBreadCrumb";
import filterObj from "./FilterInstantiation";
import Paper from "@material-ui/core/Paper";
import Chip from '@mui/material/Chip';
import { getDefaultTrendsDate } from "../../services/DateServices";
import moment from 'moment';
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { postRequest } from "../../services/ApiServices";


const useStyles = makeStyles((theme) => ({
    gridSpacing: {
        margin: "0 !important",
        width: "100% !important",
    },
    root: {
        flexGrow: 1,
        display: "flex",
        padding: "0px",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },

}));

function TrendsShips(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [shipList, setShipList] = React.useState([]);
    const [formObj, setFormObj] = React.useState(filterObj);
    const [selectedShip, setSelectedShip] = useState([]);
    
    const applyFilter = (formObj) => {
        getFilterShipListData(formObj);
        setSelectedShip([]);
    }

    const onClear = () => {
        setFormObj(filterObj)
        setSelectedShip([]);
        setShipList([]);  
    }

    const selectedShipChip = (row) => {
        setSelectedShip([...row])
    }

    const removeSelectedShipList = (row) => {
        let shipKeyIndex = selectedShip.indexOf(row);
        selectedShip.splice(shipKeyIndex,1);
        setSelectedShip([...selectedShip])
    }

    const getFilterShipListData = (formObj) => {
        let filterObj = {};
        let Data = {};
        if (formObj !== "" && formObj !== undefined) {
            if (formObj.HistoricVessel == true) {
                filterObj = { ...filterObj, HistoricVessel: [{ id: 0, name: 0 }, { id: 1, name: 1 }] }
            } else {
                filterObj = { ...filterObj, HistoricVessel: [{ id: 1, name: 1 }] }
            }
            if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
            if (formObj.shipNameImokey && formObj.shipNameImokey.length > 0) { filterObj = { ...filterObj, shipNameImokey: formObj.shipNameImokey } }
            if (formObj.Fqtbunkerport && formObj.Fqtbunkerport.length > 0) { filterObj = { ...filterObj, Fqtbunkerport: formObj.Fqtbunkerport } }
            if (formObj.lubeequipname && formObj.lubeequipname.length > 0) { filterObj = { ...filterObj, lubeequipname: formObj.lubeequipname } }
            if (formObj.lubeequipmake && formObj.lubeequipmake.length > 0) { filterObj = { ...filterObj, lubeequipmake: formObj.lubeequipmake } }
            if (formObj.Fqtfuelgrade && formObj.Fqtfuelgrade.length > 0) { filterObj = { ...filterObj, Fqtfuelgrade: formObj.Fqtfuelgrade } }
            if (formObj.FqtOffSpec && formObj.FqtOffSpec.length > 0) { filterObj = { ...filterObj, FqtOffSpec: formObj.FqtOffSpec } }
            if (formObj.Fqtlab && formObj.Fqtlab.length > 0) { filterObj = { ...filterObj, Fqtlab: formObj.Fqtlab } }
            if (formObj.FqtShipType && formObj.FqtShipType.length > 0) { filterObj = { ...filterObj, FqtShipType: formObj.FqtShipType } }
            if (formObj.FqtSupplier && formObj.FqtSupplier.length > 0) { filterObj = { ...filterObj, FqtSupplier: formObj.FqtSupplier } }
            if (formObj.Fqtbargename && formObj.Fqtbargename.length > 0) { filterObj = { ...filterObj, Fqtbargename: formObj.Fqtbargename } }
            if (formObj.Fqtsamplenumber && formObj.Fqtsamplenumber.length > 0) { filterObj = { ...filterObj, Fqtsamplenumber: formObj.Fqtsamplenumber } }
            if (formObj.servicetype && formObj.servicetype.length > 0) { filterObj = { ...filterObj, servicetype: formObj.servicetype } }
            if (formObj.ReportedDate) { filterObj = { ...filterObj, ReportedDate: formObj.ReportedDate } }
            if (formObj.ReportedDate) {
                const myJSONData = JSON.stringify(filterObj);
                Data = {
                    Data: myJSONData,
                }
            } else {
                let JSONFormat = filterObj;
                JSONFormat = { ...filterObj }
                if (formObj?.Fqtreportstartdate != null && formObj?.Fqtreportenddate != null) {
                    let ReportStartDate = (formObj?.Fqtreportstartdate[0]?.startDate ? formObj?.Fqtreportstartdate[0]?.startDate : formObj?.Fqtreportstartdate[0]);
                    let ReportEndDate = (formObj?.Fqtreportenddate[0]?.endDate ? formObj?.Fqtreportenddate[0]?.endDate : formObj?.Fqtreportenddate[0])
                    if (ReportStartDate && ReportEndDate && ReportStartDate != null && ReportEndDate != null) {
                        JSONFormat.ReportedDate = {
                            startDate: moment(ReportStartDate).format('YYYY/MM/DD'),
                            endDate: moment(ReportEndDate).format('YYYY/MM/DD')
                        }
                    }
                }
                setFormObj(JSONFormat.ReportedDate)
                const myJSONData = JSON.stringify(JSONFormat);
                Data = {
                    Data: myJSONData,
                }
            }
        }
        dispatch({ type: LOADING, payload: true });

        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Trend/ShipsList/Filter`;
        postRequest(url, Data)
            .then((res) => {
                if (res.data.length) {
                    let totalListArray = [];
                    let existingOfShipsArray = [];
                    res.data.map((row) => {
                        let listIndex = existingOfShipsArray.indexOf(row.currentVesselName);
                        if (listIndex > -1) {
                            let subObj = {
                                equimentName: row.machineryUsage,
                                equimentId: row.machineryKey
                            }

                            totalListArray[listIndex].equimentList.push(subObj);
                        } else {
                            existingOfShipsArray.push(row.currentVesselName);
                            const objEq = {
                                equimentName: row.machineryUsage,
                                equimentId: row.machineryKey
                            }
                            const obj = {
                                shipName: row.currentVesselName, shipId: row.vesselKey,
                                equimentList: [objEq]
                            }
                            totalListArray.push(obj);
                        }
                    });
                    setShipList(totalListArray);
                } else {
                    setShipList([]);
                }
                dispatch({ type: LOADING, payload: false });
            })
            .catch((error) => {
                dispatch({ type: LOADING, payload: false });
            });
    }

    return(
        <Box component="div" px={2} className={classes.root}>
            <Grid container spacing={3} className={classes.gridSpacing}>
                <TrendsBreadCrumb/>
                
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Box className="decarbox1" component="div" style={{ padding: "20px" }}  >
                            <FilterComponents screen={"trends"} defaultDate={getDefaultTrendsDate()} filtervalue={["CustomerName", "ShipName_imo", "Samplenumber", "Service_type", "Bunkerport", "Bargename", 'Fuelgrade', "Lab_Fqt", "Fuelsupplier", "FuelShipType", 'FuelOffSpec', "FqtReportDateComponent"]} applyFilter={applyFilter} reset={onClear} />
                        </Box>

                        <Grid className="ast-grid" item xs={12} sm={6} md={5} >
                            <Box component="h2" m={0} className="blcopy" fontWeight="500"
                                style={{ textAlign: "left", padding: "20px 15px" }}>
                                Selected Assets:
                            </Box>
                        </Grid>

                        <div width="100%">
                            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', }}>
                                {selectedShip.length ? selectedShip.map((item) => {
                                return (
                                <Chip
                                    label={item.shipName}
                                    onDelete={() => { removeSelectedShipList(item) }}
                                    sx={{ margin: "3px", fontSize: "12px" }}
                                />
                                )
                                }) : null}
                            </Box>
                        </div>
                    </Paper>
                </Grid>

                <Grid item xs={3} md={2}>
                    <TrendsList shipList={shipList} selectedShip={selectedShip}  selectedShipChip={selectedShipChip} />
                </Grid>
                
                <Grid item xs={9} md={10} >
                    <Grid container spacing={3} >
                        {chartObj.map(( item ) => {
                            return(
                                <Chart chartParameters={item} selectedShip={selectedShip} formObj={formObj} />
                            )                       
                        })} 
                    </Grid>
                </Grid>

            </Grid>
        </Box>
    );
}
export default TrendsShips;